var premiumVariants = {
  1: '40742340198472',  // < $100
  2: '40742340231240',  // < $200
  3: '40742340264008',  // < $300
  4: '40742340296776',  // < $400
  5: '40742340329544'   // >= $400
};
var premiumIds = Object.values(premiumVariants);

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("ella:cartChange", function (e) {
    return;
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        autoAddPremiumDeliveryServiceProducts(cart);
      });
  });
  window.addEventListener("ella:removeCart", function(e) {
    return;
    var removedItems = e.detail.items_removed;
    var premiumRemoved = false;

    for (var id of premiumIds) {
      if (removedItems.some((x) => id === x.variant_id.toString())) {
        premiumRemoved = true;
      }
    }

    if (!premiumRemoved) {
      fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
          autoAddPremiumDeliveryServiceProducts(cart)
        });
    }
  })
});

function autoAddPremiumDeliveryServiceProducts(cart) {

  var totalPrice = cart.total_price / 100;

  var correctPremium = '';

  if (totalPrice < 100) {
    correctPremium = premiumVariants[1];
  } else if (totalPrice < 200) {
    correctPremium = premiumVariants[2];
  } else if (totalPrice < 300) {
    correctPremium = premiumVariants[3];
  } else if (totalPrice < 400) {
    correctPremium = premiumVariants[4];
  } else {
    correctPremium = premiumVariants[5];
  }

  var premiumInCart = cart.items.find(item => premiumIds.includes(item.variant_id.toString()));

  if (cart.items.length === 1 && premiumInCart) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        line: 1,
        quantity: 0
      })
    })
      .then(res => res.json())
      .then(() => {
        if (window.globalElla && typeof globalElla.updateDropdownCart === "function") {
          globalElla.updateDropdownCart();
        }
      })
      .catch(err => console.error("❌ Failed to remove single premium:", err));
    return;
  }

  if (cart.items.length <= 0) {
    return;
  }

  if (premiumInCart && premiumInCart.variant_id.toString() === correctPremium) {
    if (premiumInCart.quantity !== 1) {
      var lineToUpdate = cart.items.findIndex(item => item.variant_id === premiumInCart.variant_id) + 1;

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ line: lineToUpdate, quantity: 1 })
      })
        .then(res => res.json())
        .then(() => {
          if (window.globalElla && typeof globalElla.updateDropdownCart === "function") {
            globalElla.updateDropdownCart();
          }
        })
        .catch(err => console.error("❌ Failed to fix premium quantity:", err));
    } else {
      // console.log("Correct premium variant already in cart with quantity 1.");
    }
    return;
  }

  if (premiumInCart && premiumInCart.variant_id.toString() !== correctPremium) {
    var lineToRemove = cart.items.findIndex(
      item => item.variant_id === premiumInCart.variant_id
    ) + 1; // Shopify lines are 1-based

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        line: lineToRemove,
        quantity: 0
      })
    })
      .then(res => res.json())
      .then(() => {
        addPremiumVariant(correctPremium);
      })
      .catch(err => console.error("Failed to remove old premium:", err));

    return;
  }

  if (!premiumInCart) {
    addPremiumVariant(correctPremium);
  }
}

function addPremiumVariant(variantId) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
    .then(res => res.json())
    .then(item => {
      if (window.globalElla && typeof globalElla.updateDropdownCart === "function") {
        globalElla.updateDropdownCart();
      }
    })
    .catch(err => console.error("Failed to add premium delivery service:", err));
}

function recommendationSwipe() {
    console.log('recommend swipe test');
  const imageContainers = document.querySelectorAll('.product-image.image-swap');

  imageContainers.forEach(container => {
    let touchStartX = 0;
    let touchEndX = 0;

    console.log('swipe logic');

    // 1. Swipe Logic
    container.addEventListener('touchstart', (e) => {
      console.log('touch start')
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    container.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      
      if (window.innerWidth <= 768) {
        console.log('touched');
        const swipeDistance = 50; // threshold in pixels
        const diff = touchStartX - touchEndX;

        // If swiped left (diff > 50) or right (diff < -50)
        if (Math.abs(diff) > swipeDistance) {
          container.classList.toggle('show-mobile');
        }
      }
    }, { passive: true });
  });

  const arrows = document.querySelectorAll('.custom-image-arrows-container custom-image-arrow');

  arrows.forEach(arrow => {
    arrow.addEventListener('click', (event) => {
      if (window.innerWidth <= 768) {
        event.stopPropagation();
        event.preventDefault();

        const targetElement = arrow.closest('.product-image.image-swap'); 
        if (targetElement) {
          targetElement.classList.toggle('show-mobile');
        }
      }
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 768) {
      const activeElements = document.querySelectorAll('.product-image.image-swap.show-mobile');
      
      activeElements.forEach(el => {
        el.classList.remove('show-mobile');
      });
    }
  });

}

// Accessibility Fix: Add aria label to dynamic klaviyo button
const forceFavoritesLabel = () => {
  const favButton = document.querySelector('.kl-hub-favorites-widget');
  
  if (favButton) {
    if (favButton.getAttribute('aria-label') !== 'Add to favorites') {
      favButton.setAttribute('aria-label', 'Add to favorites');
    }
  }
};

setInterval(forceFavoritesLabel, 500);

document.addEventListener('DOMContentLoaded', forceFavoritesLabel);

// Accessibility Fix: Add aria labels to the Contribe app buttons
const forceShadowContribeLabels = () => {
  const shadowHost = document.querySelector('contribe-plugin');
  
  if (shadowHost && shadowHost.shadowRoot) {
    const projectButtons = shadowHost.shadowRoot.querySelectorAll('.contribe-selector-project-button');
    
    projectButtons.forEach((button, index) => {
      const targetLabel = `Select donation project ${index + 1}`;
      
      if (button.getAttribute('aria-label') !== targetLabel) {
        button.setAttribute('aria-label', targetLabel);
      }
    });
  }
};

setInterval(forceShadowContribeLabels, 400);

document.addEventListener('DOMContentLoaded', forceShadowContribeLabels);